import { isMobile, isTablet } from 'react-device-detect';

export default {
  isMobile: isMobile,
  isTablet: isTablet
};
